import { Box, Text, Image, Heading } from "grommet";
import * as React from "react";
import LinkButton from "../components/LinkButton";
import { GetAttendeeMetadata, useUser } from "../utils/AccountStore";
import { GetMetadata, Metadata } from "../utils/MetadataStore";
import RightArrow from "../components/RightArrow";
import { Scope, createScope, animate, createSpring, createDraggable } from "animejs";
import { useNavigate } from "react-router-dom";
import { useSwipeable } from "react-swipeable";

const Splash = () => {
    const maxSize = screen?.width > 800 ? "200px" : "100%";
    const logoMaxSize = screen?.width > 600 ? "200px" : "100%";

    const { user } = useUser();

    const [nextPage, setNextPage] = React.useState("/home");

    React.useEffect(() => {
        setNextPage("/home");
        navigate("/home");
        // if (user.metadata) {
        //     let metadata = GetAttendeeMetadata(user);

        //     if (!metadata.terms) {
        //         setNextPage("/profile");
        //         navigate("/profile");
        //     } else {
        //     }
        // } else {
        //     setNextPage("/profile");
        //     navigate("/profile");
        // }
    }, [user]);

    const [metadata, setMetadata] = React.useState({} as Metadata);

    React.useEffect(() => {
        GetMetadata().then((res) => {
            setMetadata(res);
        });
    }, []);

    const navigate = useNavigate();

    const handlers = useSwipeable({
        onSwipedRight: () => navigate(nextPage),
    });

    const root = React.useRef(null);
    const scope = React.useRef<Scope | null>(null);

    // const [rotations, setRotations] = useState(0);

    React.useEffect(() => {
        if (scope) {
            scope.current = createScope({ root }).add((self) => {
                // Every anime.js instances declared here are now scopped to <div ref={root}>

                // Created a bounce animation loop
                animate(".arrow", {
                    scale: [
                        { to: 1.25, ease: "inOut(3)", duration: 200 },
                        { to: 1, ease: createSpring({ stiffness: 300 }) },
                    ],
                    loop: true,
                    loopDelay: 250,
                    delay: (_, i) => i * 50, // Function based value
                });

                animate("span", {
                    // Property keyframes
                    y: [
                        { to: "-0.25rem", ease: "outExpo", duration: 600 },
                        { to: 0, ease: "outBounce", duration: 800, delay: 100 },
                    ],
                    // Property specific parameters
                    // rotate: {
                    //     from: "-1turn",
                    //     delay: 0,
                    // },
                    delay: (_, i) => i * 50, // Function based value
                    ease: "inOutCirc",
                    loopDelay: 1000,
                    loop: true,
                });
            });
            // Properly cleanup all anime.js instances declared inside the scope
        }

        return () => scope?.current?.revert();
    }, [scope]);

    return (
        <Box align="center" justify="center" height={"var(--vh)"} width={"100vw"} ref={root} background={{ image: "url('/images/background.png')" }}>
            <Box align="center" pad={"small"} width={"75vw"} round="medium" gap={"small"}>
                <Image margin="small" fit="contain" src={metadata.eventLogo} width={logoMaxSize} />
                {/* <Heading level={2} weight={"bold"}>
                    {metadata.eventName}
                </Heading> */}
                {/* <Box align="center" gap={"small"} onClick={() => navigate(nextPage)}>
                    <Box direction="row" gap="small" align="center" {...handlers}>
                        <RightArrow className="arrow" size="50px" color={"#b4021f"} />
                        <RightArrow className="arrow" size="50px" color={"#000"} />
                        <RightArrow className="arrow" size="50px" color={"#b4021f"} />
                        <RightArrow className="arrow" size="50px" color={"#000"} />
                    </Box>
                    <Box direction="row" gap="small" align="center">
                        <span>S</span>
                        <span>W</span>
                        <span>I</span>
                        <span>P</span>
                        <span>E</span>
                        <span>&nbsp;</span>
                        <span>T</span>
                        <span>O</span>
                        <span>&nbsp;</span>
                        <span>G</span>
                        <span>E</span>
                        <span>T</span>
                        <span>&nbsp;</span>
                        <span>S</span>
                        <span>T</span>
                        <span>A</span>
                        <span>R</span>
                        <span>T</span>
                        <span>E</span>
                        <span>D</span>
                    </Box> */}
                {/* {user.id && <LinkButton label="Get Started" path={nextPage}></LinkButton>} */}
                {/* </Box> */}
            </Box>
        </Box>
    );
};

export default Splash;
